import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDoc: null,
};

export const AuditDocumentViewer = createSlice({
  name: "AuditDocumentViewer",
  initialState,
  reducers: {
    updateSelectedDoc: (state, action) => {
      return {
        ...state,
        selectedDoc: action.payload,
      };
    },
  },
});

export const { updateSelectedDoc } = AuditDocumentViewer.actions;

export default AuditDocumentViewer.reducer;
